import { render, staticRenderFns } from "./BusinessInfoCard.vue?vue&type=template&id=1f71e55c&"
import script from "./BusinessInfoCard.vue?vue&type=script&lang=js&"
export * from "./BusinessInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports